import { j as t } from "../../node_modules/react/jsx-runtime.js";
import o from "../../context/provider.js";
import s from "./just-text.js";
const x = (r) => /* @__PURE__ */ t.jsx(o, { initialState: r, children: /* @__PURE__ */ t.jsx(s, {}) });
export {
  x as default
};
